<template>
    <div class="mod-config">
        <el-form :inline="true" :model="dataForm" size="small" @keyup.enter.native="getDataList()">
            <el-form-item>
                <el-input v-model="dataForm.bizCode" placeholder="模板编码" clearable></el-input>
            </el-form-item>
            <el-form-item>
                <el-input v-model="dataForm.name" placeholder="模板名称" clearable></el-input>
            </el-form-item>
            <el-form-item>
                <el-button size="small" @click="getDataList()" icon="el-icon-search">查询
                </el-button>
                <el-button
                        size="small"
                        type="primary"
                        @click="uploadHandle()" icon="el-icon-plus">新建
                </el-button>
            </el-form-item>
        </el-form>
        <el-table
                :height=documentClientHeight
                :data="dataList"
                size="small"
                v-loading="dataListLoading"
                @selection-change="selectionChangeHandle"
                style="width: 100%;">
            <el-table-column
                    prop="bizCode"
                    header-align="center"
                    align="center"
                    label="模板代码">
            </el-table-column>
            <el-table-column
                    prop="name"
                    header-align="center"
                    align="center"
                    label="模板名称">
            </el-table-column>
            <el-table-column
                    prop="updateTime"
                    header-align="center"
                    align="center"
                    label="上传时间" :formatter="dateFormat">
            </el-table-column>
            <el-table-column
                    prop="dummyName"
                    header-align="center"
                    align="center"
                    label="加密后文档名称">
            </el-table-column>
            <el-table-column
                    fixed="right"
                    header-align="center"
                    align="center"
                    width="170"
                    label="操作">
                <template slot-scope="scope">
                    <el-row :span="15">
                        <el-col :span="8">
                            <el-button type="text" size="small" @click="uploadHandle(scope.row.id, scope.row.bizCode, scope.row.name)">修改
                            </el-button>
                        </el-col>
                        <el-col :span="8">
                            <el-button type="text" size="small" @click="deleteHandle(scope.row.id)">删除
                            </el-button>
                        </el-col>
                    </el-row>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
                @size-change="sizeChangeHandle"
                @current-change="currentChangeHandle"
                :current-page="pageIndex"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="pageSize"
                :total="totalPage"
                layout="total, sizes, prev, pager, next, jumper">
        </el-pagination>
        <!-- 弹窗, 新增 / 修改 -->
        <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
        <tmpl-upload v-if="tmplUploadVisible" ref="tmplUpload" @refreshDataList="getDataList"></tmpl-upload>
    </div>
</template>

<script>
    import {listOfficeTemplate, batchDeletePoiTmpl} from '@/controller/sys'
    import AddOrUpdate from './template-add-or-update'
    import TmplUpload from './tmpl-upload'
import moment from 'moment'
    export default {
        data() {
            return {
                uploadData: {
                    id: 0
                },
                dataForm: {
                    bizCode: '',
                    name: ''
                },
                tenantList: [],
                uploadURL: '',
                dataList: [],
                pageIndex: 1,
                pageSize: 10,
                totalPage: 0,
                dataListLoading: false,
                dataListSelections: [],
                addOrUpdateVisible: false,
                tmplUploadVisible: false
            }
        },
        components: {
            AddOrUpdate,
            TmplUpload
        },
        activated() {
            this.getDataList()
        },
        methods: {
            dateFormat: function (row, column) {
                var date = row[column.property]
                if (!date) {
                    return ''
                }
                return moment(date).format("YYYY-MM-DD HH:mm:ss")
            },
            tenantFormatter(row) {
                let tenant = row.tenant
                for (const i of this.tenantList) {
                    if (tenant === i.code) {
                        return i.name
                    }
                }
            },
            getSelectHandler(row) {
                this.dataListSelections = row
            },
            beforeUploadHandle() {
                this.uploadData.id = this.dataListSelections && this.dataListSelections.mailtemplateId
            },
            // 获取数据列表
            getDataList() {
                this.dataListLoading = true
                listOfficeTemplate({
                    'pageNo': this.pageIndex,
                    'pageSize': this.pageSize,
                    'bizCode': this.dataForm.bizCode,
                    'name': this.dataForm.name,
                }).then(data => {
                    if (data && data.code === '00') {
                        this.dataList = data.body.records
                        this.totalPage = data.body.total
                    } else {
                        this.dataList = []
                        this.totalPage = 0
                    }
                    this.dataListLoading = false
                })
            },
            // 每页数
            sizeChangeHandle(val) {
                this.pageSize = val
                this.pageIndex = 1
                this.getDataList()
            },
            // 当前页
            currentChangeHandle(val) {
                this.pageIndex = val
                this.getDataList()
            },
            // 上传成功
            successHandle(response) {
                if (response && response.code === 0) {
                    this.$message({
                        message: '上传成功！！',
                        type: 'success'
                    });
                    this.getDataList()
                } else {
                    this.$message.error(response.msg)
                }
            },
            // 多选
            selectionChangeHandle(val) {
                this.dataListSelections = val
            },
            // 新增 / 修改
            addOrUpdateHandle(id) {
                this.addOrUpdateVisible = true
                this.$nextTick(() => {
                    this.$refs.addOrUpdate.init(id)
                })
            },
            uploadHandle(id, code, name) {
                this.tmplUploadVisible = true
                this.$nextTick(() => {
                    this.$refs.tmplUpload.init(id, code, name)
                })
            },
            // 删除
            deleteHandle(id) {
                let ids = id ? [id] : this.dataListSelections.map(item => {
                    return item.id
                })
                this.$confirm(`确定进行${id ? '删除' : '批量删除'}操作?`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    batchDeletePoiTmpl(
                        ids
                    ).then(data => {
                        if (data && data.code === '00') {
                            this.$message({
                                message: '操作成功',
                                type: 'success',
                                duration: 1500,
                                onClose: () => {
                                    this.getDataList()
                                }
                            })
                        } else {
                            this.$message.error(data.msg)
                        }
                    })
                }).catch(() => {})
            }
        }
    }
</script>
